import { AngularFireDatabase } from '@angular/fire/compat/database'
import { Injectable } from '@angular/core'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import { defer, Observable } from 'rxjs'
import { AppUser, AppUserDto } from '../models/app-user.model'
import { map, take } from 'rxjs/operators'
import { AngularFireFunctions } from '@angular/fire/compat/functions'

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private db: AngularFireDatabase, private cloudFunctions: AngularFireFunctions) {}

  save(user: firebase.User) {
    this.db.object('/users/' + user.uid).update({
      name: user.displayName,
      email: user.email,
    })
  }

  get(uid: string): Observable<AppUser | null> {
    return this.db
      .object<AppUser>('/users/' + uid)
      .snapshotChanges()
      .pipe(
        map(appUserSnapshots => {
          const data = appUserSnapshots.payload.val()
          const id = appUserSnapshots.payload.key
          return data ? { id, ...data } : null
        })
      )
  }

  getAll(): Observable<AppUser[]> {
    return this.db
      .list<AppUser>('/users/')
      .snapshotChanges()
      .pipe(
        map(appUserSnapshots =>
          appUserSnapshots.map(appUserSnapshot => ({
            id: appUserSnapshot.payload.key,
            ...appUserSnapshot.payload.val(),
          }))
        )
      )
  }

  getAllOrganizations(): Observable<AppUser[]> {
    return this.db
      .list<AppUser>('/users/', ref => ref.orderByChild('isOrganization').equalTo(true)) // Szűrés az adatbázis lekérdezés szintjén
      .snapshotChanges()
      .pipe(
        map(appUserSnapshots =>
          appUserSnapshots.map(appUserSnapshot => ({
            id: appUserSnapshot.payload.key,
            ...appUserSnapshot.payload.val(),
          }))
        )
      )
  }

  updateOrganization(user: AppUserDto, userId: string, isOrganization: boolean) {
    this.db.object('/users/' + userId).update({
      isOrganization: isOrganization,
    })
  }

  deleteUser(userId: string): Observable<void> {
    return defer(() => this.cloudFunctions.httpsCallable('deleteUser')({ userId })).pipe(map(() => undefined))
  }

  deleteUserSelf(): Observable<void> {
    return defer(() => this.cloudFunctions.httpsCallable<Record<string, never>, unknown>('deleteUserSelf')({})).pipe(
      map(() => undefined)
    )
  }

  getUserName(uid: string): Promise<string> {
    return this.db
      .object(`/users/${uid}/name`)
      .valueChanges()
      .pipe(
        take(1),
        map((name: string | null) => name || 'Ismeretlen felhasználó')
      )
      .toPromise()
  }
}
